import React from "react";
import { MessageCircle } from "lucide-react";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
const TEXT = encodeURIComponent("Hello Queen MJ Maison Beaute, I have a question about a fragrance.");

export default function WhatsAppButton() {
  if (!NUMBER) return null;
  return (
    <a
      href={`https://wa.me/${NUMBER}?text=${TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-button"
      className="fixed bottom-5 right-5 z-[60] group flex items-center gap-2 pl-3.5 pr-4 py-3 rounded-full bg-[#25D366] text-[#0B0B0C] shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-105 hover:-translate-y-0.5"
    >
      <MessageCircle size={20} strokeWidth={2.2} />
      <span className="text-sm font-medium tracking-wide">Chat with us</span>
    </a>
  );
}
